import Cookie from 'js-cookie'
import { AnalyticsBrowser } from '@segment/analytics-next'
import { ChordAnalytics, type ObjectTypes } from '@chordcommerce/analytics'
import {
  cartFormatter,
  checkoutFormatter,
  lineItemFormatter,
  productFormatter,
} from '@/config/chord-analytics-formatters'

const segment_key = import.meta.env.PUBLIC_SEGMENT_ANALYTICS_KEY

const analytics = new AnalyticsBrowser()

if (typeof window !== 'undefined') {
  analytics.addSourceMiddleware(({ payload, next }) => {
    let consents = {}
    const ketchToken = Cookie.get('_ketch_consent_v1_')
    if (ketchToken) {
      const decodedConsents = JSON.parse(atob(ketchToken))

      consents = Object.keys(decodedConsents).reduce(
        (acc, key) => {
          acc[key] = decodedConsents[key].status === 'granted'
          return acc
        },
        {} as Record<string, boolean>,
      )
    }

    payload.obj.context = {
      ...payload.obj.context,
      consent: {
        categoryPreference: { ...consents },
      },
    }

    next(payload)
  })

  analytics.load({ writeKey: segment_key })
}

export const chord = new ChordAnalytics<ObjectTypes>({
  cdp: () => analytics,
  formatters: {
    objects: {
      cart: cartFormatter,
      checkout: checkoutFormatter,
      lineItem: lineItemFormatter,
      product: productFormatter,
    },
  },
  metadata: {
    i18n: {
      currency: 'USD',
      locale: 'en-us',
    },
    ownership: {
      omsId: import.meta.env.PUBLIC_OMS_ID,
      storeId: import.meta.env.PUBLIC_STORE_ID,
      tenantId: import.meta.env.PUBLIC_TENANT_ID,
    },
    platform: {
      name: 'Shopify',
      type: 'web',
    },
    store: {
      domain: import.meta.env.PUBLIC_SHOPIFY_STORE_NAME,
    },
  },
})

export const segment_analytics = analytics
